import { UtilsService } from '../../../services/utils.service';
import { ErrorResponse } from '../../../models/error.model';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from '../../../services/services.service';
import { Service } from '../../../models/service.model';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-service-details',
    templateUrl: './service-details.component.html',
    styleUrls: ['./service-details.component.scss']
})
export class ServiceDetailsComponent implements OnInit {

    service?: Service;

    constructor(
        private servicesService: ServicesService,
        private route: ActivatedRoute,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.servicesService.getServiceById(params.id).subscribe(
                    service => this.service = service,
                    (error: ErrorResponse) => this.utilsService.alert('Error al obtener el servicio seleccionado', error.error?.descripcion)
                );
            }
        });
    }

}
